<button (click)="login()" class="abx-nav-text-link">Log in / Signup</button>
